<app-filters-dropdown-item
    [title]="'filters.project.projectDomains' | translate"
    collapseId="projectTypesCollapse"
    [options]="projectTypesFilterItems"
    (selectionChange)="onProjectTypesSelectionChanged()"
></app-filters-dropdown-item>
